// 여러 항목을 최대 concurrency개까지 동시에 처리하는 워커 풀 방식의 유틸리티.
// 정해진 개수만큼 끊어 기다리는 고정 배치와 달리, 워커 하나가 끝나는 즉시 다음
// 항목을 이어서 처리하므로 느린 항목 하나 때문에 나머지가 대기하지 않는다.
// (업로드/카카오톡 발송처럼 동시 요청 수를 제한해야 하는 배치 API 호출에서 재사용)
export async function runWithConcurrency<T>(
  items: T[],
  concurrency: number,
  worker: (item: T, index: number) => Promise<void>,
  isCancelled?: () => boolean
): Promise<void> {
  let nextIndex = 0;

  const runWorker = async () => {
    while (nextIndex < items.length) {
      if (isCancelled?.()) return;
      const index = nextIndex;
      nextIndex += 1;
      await worker(items[index], index);
    }
  };

  const workerCount = Math.min(concurrency, items.length);
  await Promise.all(Array.from({ length: workerCount }, runWorker));
}
